/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Pagination1OfVehicleTemplateDto } from '../models/Pagination1OfVehicleTemplateDto';
import type { PostPutVehicleTemplateRequestAdmin } from '../models/PostPutVehicleTemplateRequestAdmin';
import type { VehicleTemplateDto } from '../models/VehicleTemplateDto';
import type { VehicleTemplateType } from '../models/VehicleTemplateType';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class VehicleTemplatesService {
    /**
     * **Required Policy:** `ManageVehicles`
     * @returns VehicleTemplateDto Created
     * @throws ApiError
     */
    public static postVehicleTemplateAdmin({
        requestBody,
    }: {
        requestBody?: PostPutVehicleTemplateRequestAdmin,
    }): CancelablePromise<VehicleTemplateDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/vehicletemplates',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewVehicles`
     * @returns Pagination1OfVehicleTemplateDto OK
     * @throws ApiError
     */
    public static getVehicleTemplatesAdmin({
        searchWord,
        type,
        maxConcurrentDelivery,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        searchWord?: string,
        type?: VehicleTemplateType,
        maxConcurrentDelivery?: number,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfVehicleTemplateDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/vehicletemplates',
            query: {
                'searchWord': searchWord,
                'type': type,
                'maxConcurrentDelivery': maxConcurrentDelivery,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewVehicles`
     * @returns VehicleTemplateDto OK
     * @throws ApiError
     */
    public static getVehicleTemplateAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<VehicleTemplateDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/vehicletemplates/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageVehicles`
     * @returns VehicleTemplateDto OK
     * @throws ApiError
     */
    public static putVehicleTemplateAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PostPutVehicleTemplateRequestAdmin,
    }): CancelablePromise<VehicleTemplateDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/vehicletemplates/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteVehicles`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteVehicleTemplateAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/vehicletemplates/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
